module.exports = __webpack_public_path__ + "img/tsh_qcode.b935939e.png";